// Normalizar nombres (minúsculas, sin tildes, sin espacios extra)
const normalize = (str) => {
  return str
    .toLowerCase()
    .normalize('NFD')
    .replaceAll(/\p{Diacritic}/gu, '')
    .replaceAll(/[^a-z\s]/g, '')
    .replaceAll(/\s+/g, ' ')
    .trim();
};

/* Casos en la db:
"Santander - Cesar"
"Cauca - Valle del Cauca"
"Santander"
"Bolivar"
"Atlantico"
"Bolívar - Atlántico"
"Valle del Cauca"
*/

const regionMap = {
  // Región Caribe (Norte)
  bolivar: 'Caribe (Norte)',
  'bolivar atlantico': 'Caribe (Norte)',
  cesar: 'Caribe (Norte)',
  atlantico: 'Caribe (Norte)',
  // Región Pacífica (Occidente)
  'valle del cauca': 'Pacífica (Occidente)',
  'cauca valle del cauca': 'Pacífica (Occidente)',
  cauca: 'Pacífica (Occidente)',
  // Región Andina (Centro-Oriente)
  'santander cesar': 'Andina (Centro-Oriente)',
  santander: 'Andina (Centro-Oriente)',
};

// Busca directamente en regionMap usando la clave normalizada (con o sin guion)
const getRegionByDepartment = (departmentName) => {
  if (!departmentName) return null;
  const key = normalize(departmentName.replaceAll('-', ' '));
  return regionMap[key] || null;
};

export const transform = (data) => {
  if (!data || typeof data !== 'object') return data;
  const region = getRegionByDepartment(data.farm_region);
  data.farm_region = region ? `${region}, ${data.farm_region}` : data.farm_region;
  return data;
};
